import React, { useEffect } from "react";
import Style from "./Home.module.scss";
import me from "../../img/self.png";
import classNames from "classnames";
import EmojiBullet from "./EmojiBullet";
import SocialIcon from "./SocialIcon";
import { Box } from "@mui/material";
import { infoEn } from "../../info/InfoEn"; // Import English info file
import Typed from "../../vendor/typed.js/typed.min";

export default function HomeEn() {
  useEffect(() => {
    const typed = new Typed(".typing", {
      strings: [
        "AI Engineer",
        "DT Engineer",
        "Developer",
        "Mechatronics Engineer",
        "Python Expert",
        "Data Scientist",
      ],
      loop: true,
      typeSpeed: 65,
      backSpeed: 65,
    });

    // Cleanup
    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <Box
      component={"main"}
      display={"flex"}
      flexDirection={{ xs: "column", md: "row" }}
      alignItems={"center"}
      justifyContent={"center"}
      minHeight={"calc(100vh - 175px)"}
      px={{ xs: 1, md: 2 }}
    >
      <Box
        className={classNames(Style.avatar, Style.shadowed)}
        alt={"image of developer"}
        style={{ background: infoEn.gradient }}
        component={"img"}
        src={me}
        borderRadius={"50%"}
        p={"0.75rem"}
        mb={{ xs: "2rem", md: 0 }}
        mr={{ xs: 0, md: "2rem" }}
      />
      <Box
        width={{ xs: "100%", md: "auto" }}
        textAlign={{ xs: "center", md: "left" }}
        fontFamily={"JetBrains Mono"}
      >
        <h1 style={{ fontFamily: "JetBrains Mono" }}>
          Hello, I&apos;m{" "}
          <span
            style={{
              background: infoEn.gradient,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}
          >
            {infoEn.firstName}
          </span>
          <span className={Style.hand}>🤚</span>
        </h1>
        <h2 style={{ fontFamily: "JetBrains Mono" }}>
          <span className={`typing ${Style.typing}`}></span>
        </h2>
        <Box
          component={"ul"}
          p={{ xs: "0.5rem", md: "0.8rem" }}
          fontFamily={"JetBrains Mono"}
          sx={{ listStyle: "none", listStyleType: "none" }}
        >
          {infoEn.miniBio.map((bio, index) => (
            <EmojiBullet key={index} emoji={bio.emoji} text={bio.text} />
          ))}
        </Box>
        <Box
          display={"flex"}
          gap={{ xs: "1rem", md: "1.5rem" }}
          justifyContent={"center"}
          fontSize={{ xs: "1.5rem", md: "2rem", lg: "2.5rem" }}
          flexWrap={"wrap"}
        >
          {infoEn.socials.map((social, index) => (
            <SocialIcon
              key={index}
              link={social.link}
              icon={social.icon}
              label={social.label}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
